import React from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@mui/styles';
import { enqueueSnackbar } from 'notistack'
import ListItemIcon from "@mui/material/ListItemIcon/ListItemIcon";
import ListItemText from "@mui/material/ListItemText/ListItemText";
import ListItem from "@mui/material/ListItem/ListItem";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import {getErrorMessageFromResponse} from "../common/helper";
import Button from "@mui/material/Button/Button";

const styles = theme => ({
    menuListItem: {
        color: theme.menuListItem.colour
    },
    listIcon: {
        minWidth: theme.spacing(4),
        color: theme.menuListItem.colour
    },
});


function TestSharePoint(props) {

    const debug = true

    const getAllSPItems = async() => {

        //TEST CODE TO GET ALL ITEMS IN LIBRARY
        const pathVar = "/api/sp/library/items"
        const url = window.REACT_APP_CONTENT_API_BASE_URL  + pathVar;
        const request = {
            headers: {"Authorization": "Bearer " + props.userDetails.accessToken}
        };

        debug && console.log ('REQUEST.  url:', url, 'request: ', request);

        fetch(url, request)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    debug && console.log ('response not ok - get all SharePoint items RESPONSE: ', response);
                    Promise.resolve(getErrorMessageFromResponse(response, "retrieving items from Sharepoint" ))
                        .then(message => {
                            let options= { variant: 'error'}
                            if (response.status === 401 && props.logout) {
                                options.action = <Button style={{color: 'white'}} onClick={() => props.logout()}>Logout</Button>
                                options.autoHideDuration = 10000
                            }
                            enqueueSnackbar(message, options);

                        })

                    debug && console.log (" get all SharePoint items error. url:", url, "request: ", request, "response:", response);
                    return null
                }
            })
            .then(resultA => {
                console.log ('get all SharePoint items response.json: ', resultA);
                }
            )
            .catch(e => {
                debug && console.log (" get all SharePoint items Exception:", e, "url:", url, "request: ", request);
                enqueueSnackbar("Search exception: " + e.message,{ variant: 'error'});
            })

    };

    const { classes, addFolderConfig, ...other } = props;

    return(

        <React.Fragment>
            <Tooltip title={"Test getting Sharepoint content"}>
                <ListItem
                    button={true}
                    key={'testSP'}
                    id={'testSP'}
                    onClick={getAllSPItems}
                >
                    <ListItemIcon  className={classes.listIcon}><i className='material-icons'>not_listed_location</i></ListItemIcon>
                    <ListItemText className={classes.menuListItem} primary={"Test Sharepoint"}/>
                </ListItem>
            </Tooltip>


        </React.Fragment>
    )

}

TestSharePoint.propTypes = {
    classes: PropTypes.object,
    userDetails: PropTypes.object.isRequired,
    metadataConfig: PropTypes.object.isRequired,
    optionsConfig: PropTypes.object.isRequired,
    triggerRefreshAuthToken: PropTypes.func.isRequired,
    addFolderConfig: PropTypes.object.isRequired
};


export default (withStyles(styles, { withTheme: true })(TestSharePoint));
